import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 4.084H8.668a.75.75 0 1 1 0-1.5H14a.75.75 0 1 1 0 1.5ZM14.748 6a.75.75 0 0 0-.75-.75h-5.33a.75.75 0 0 0 0 1.5H14a.75.75 0 0 0 .748-.75Zm-7.994-.335v-2A1.753 1.753 0 0 0 5 1.918H3a1.753 1.753 0 0 0-1.75 1.75v2A1.752 1.752 0 0 0 3 7.418h2a1.752 1.752 0 0 0 1.754-1.753ZM5 3.418a.251.251 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H3a.25.25 0 0 1-.25-.25v-2a.251.251 0 0 1 .25-.25ZM14.748 10a.75.75 0 0 0-.75-.75h-5.33a.75.75 0 1 0 0 1.5H14a.75.75 0 0 0 .748-.75Zm0 2.665a.75.75 0 0 0-.75-.75h-5.33a.75.75 0 1 0 0 1.5H14a.75.75 0 0 0 .748-.754Zm-7.994-.334v-2A1.752 1.752 0 0 0 5 8.58H3a1.752 1.752 0 0 0-1.75 1.75v2A1.753 1.753 0 0 0 3 14.08h2a1.753 1.753 0 0 0 1.754-1.753ZM5 10.08a.25.25 0 0 1 .25.25v2a.251.251 0 0 1-.25.25H3a.251.251 0 0 1-.25-.25v-2a.25.25 0 0 1 .25-.25Z';
const draw24px =
  'M21.754,19a.749.749,0,0,1-.75.75H13a.75.75,0,0,1,0-1.5h8A.755.755,0,0,1,21.754,19Zm-12-13V8A2.755,2.755,0,0,1,7,10.746H5A2.748,2.748,0,0,1,2.254,8V6A2.755,2.755,0,0,1,5,3.246H7A2.761,2.761,0,0,1,9.754,6Zm-1.5,0A1.25,1.25,0,0,0,7,4.746H5A1.25,1.25,0,0,0,3.754,6V8A1.25,1.25,0,0,0,5,9.246H7A1.25,1.25,0,0,0,8.254,8ZM21,8.246H13a.75.75,0,0,0,0,1.5h8a.75.75,0,0,0,0-1.5Zm-8-2.5h8a.75.75,0,0,0,0-1.5H13a.75.75,0,0,0,0,1.5ZM9.754,16v2A2.755,2.755,0,0,1,7,20.746H5A2.748,2.748,0,0,1,2.254,18V16A2.755,2.755,0,0,1,5,13.246H7A2.761,2.761,0,0,1,9.754,16Zm-1.5,0A1.25,1.25,0,0,0,7,14.746H5A1.25,1.25,0,0,0,3.754,16v2A1.25,1.25,0,0,0,5,19.246H7A1.25,1.25,0,0,0,8.254,18ZM21,14.246H13a.75.75,0,0,0,0,1.5h8a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LayoutCardListStackedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'layoutCardListStacked')) as IconWithRender;

LayoutCardListStackedIcon.displayName = 'LayoutCardListStackedIcon';
LayoutCardListStackedIcon.propTypes = Icon.propTypes;
LayoutCardListStackedIcon.renderIcon = (props) => (
  <LayoutCardListStackedIcon {...props} />
);
export default LayoutCardListStackedIcon;
